import React, { Component } from 'react'
import { authContext } from '../../Login/AuthContext';
import AsyncCSV from '../../config/ExportCSV'
import {Chart as ChartJS,defaults,CategoryScale,LinearScale,BarElement,Title,Tooltip,Legend,ArcElement} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(CategoryScale);
ChartJS.register(LinearScale);
ChartJS.register(BarElement);
ChartJS.register(ArcElement);
ChartJS.register(Title);
ChartJS.register(Tooltip);
ChartJS.register(Legend);

export default class VentilationTotalTypes extends Component {
  static contextType = authContext;

  componentDidMount = () => {
    this.updateVentilationTotalTypes(this.context.auth.data);
  }

  headerVentilation = [
    {label:"code", key:"code"},
    {label:"type", key:"type"},
    {label:"NbInDatabase", key:"NbInDatabase"},
    {label:"NbReviewsInDatabase", key:"NbReviewsInDatabase"}
  ]

  static chartDataBookingAllTypes = null;
  static chartDataBookingAllReviews = null;

  toCSV = (csvFile, data) => {
    var dataCSV = this.context.auth.data.dataCSV;
    if(!dataCSV)
      dataCSV = [];
    if(!dataCSV[csvFile])
      dataCSV[csvFile] = [];
    for(var j=0;j<data.length;j++){
      var d = data[j];

        var found = 0;
        for(var i=0; i<dataCSV[csvFile].length;i++){
            if(dataCSV[csvFile][i].code == d.code)
                found = 1;
        }
        if(!found)
            dataCSV[csvFile].push(d)
    }
    this.context.setAuthData(this.context.auth.data);
  }

  updateVentilationTotalTypes = (data) => {

    if(!data.zone)
      return;
    fetch("https://mel.dvrc.fr/api/GetBookingDataTypeAllFromShapeGID36.php?shape_gid="+data.zone.shapes+"&token="+data.token)
      .then(res => res.json())
      .then( (data) => {
      this.toCSV("VentilationTotal", data)
      var pie_dataBookingAllTypes = {
        type: 'pie',
        data: {
          datasets: [{
            data: [],
            backgroundColor: [global.palette2[0],global.palette2[1],global.palette2[2],global.palette2[3],global.palette2[4],global.palette2[5],global.palette2[6],global.palette2[7]],
            label: 'All accommodation types'
          }], labels: []
        },
        options: {responsive: true, plugins:{title: {display: true,text:'Répartition des établissements (Booking)'}}}
      };
      var pie_dataBookingAllReviews = {
          type: 'pie',
          data: {
            datasets: [{
              data: [],
              backgroundColor: [global.palette2[0],global.palette2[1],global.palette2[2],global.palette2[3],global.palette2[4],global.palette2[5],global.palette2[6],global.palette2[7]],
              label: 'All accommodation reviews'
            }], labels: []
          },
          options: {responsive: true, title: {display: true,text:'Répartition des commentaires (Booking)'}}
        };

        for(var j in data)
        {
            var itemValues=Object.values(data[j]);
            pie_dataBookingAllTypes.data.datasets[0].data.push(itemValues[2])
            pie_dataBookingAllTypes.data.labels.push(itemValues[1])
            pie_dataBookingAllReviews.data.datasets[0].data.push(itemValues[3])
            pie_dataBookingAllReviews.data.labels.push(itemValues[1])
        }

        if(document.getElementById('dataBookingAllTypes')){
          var ctx = document.getElementById('dataBookingAllTypes').getContext('2d');
          if(this.chartDataBookingAllTypes != null)
            this.chartDataBookingAllTypes.destroy()
          //window.myPie
          this.chartDataBookingAllTypes = new ChartJS(ctx, pie_dataBookingAllTypes);
          ctx = document.getElementById('dataBookingAllReviews').getContext('2d');
          //window.myPie
          if(this.chartDataBookingAllReviews != null)
            this.chartDataBookingAllReviews.destroy()
          this.chartDataBookingAllReviews = new ChartJS(ctx, pie_dataBookingAllReviews);
        }
      });
  }

  render (){
    return (
      <div className="container">
          <div className="alert alert-primary" role="alert">Répartition totale par type d'établissement -
            <AsyncCSV name={this.context.auth.data.zone.name+"_VentilationTotal"} header={this.headerVentilation} dataCSV="VentilationTotal"/>
          </div>
          <div className="row">
            <div className="col"><canvas id="dataBookingAllTypes" width="50%"></canvas></div>
            <div className="col"><canvas id="dataBookingAllReviews" width="50%"></canvas></div>
          </div>
      </div>
    )
  }
}
